module.exports = __webpack_public_path__ + "img/cockade.e92dba5b.png";